<style lang="scss" scoped>
</style>

<template>
    <div class="order-form mb-40 mb-lg-0">
        <el-form ref="form" @submit="submit" :loading="loading" :success="success" :error="server_error">

            <p class="h3 font-weight-bold mb-40">Contacteer ons</p>
            <div class="row mb-24">
                <el-input v-model="data.first_name" class="col-12 mb-24" label="Voornaam" rules="required" />
                <el-input v-model="data.last_name" class="col-12 mb-24" label="Achternaam" rules="required" />
                <el-input v-model="data.company" class="col-12 mb-24" label="Bedrijf" rules="required" />
                <el-input v-model="data.email" class="col-12 mb-24" type="email" label="E-mailadres" rules="required|email" />
                <el-input v-model="data.phone" class="col-12 mb-24" label="Telefoonnummer" rules="required" />
                <el-input v-model="data.message" class="col-12 mb-0" type="textarea" label="Bericht" />
            </div>
        </el-form>
    </div>
</template>

<script>
import hasForm from '../mixins/has-form'

export default {
    name: "form.el-contact-form",

    mixins: [hasForm],

    data: () => ({
        data: {
            first_name: '',
            last_name: '',
            company: '',
            email: '',
            phone: '',
            message: ''
        }
    }),

    methods: {
        submit() {
            this.beforeSubmit()
            axios.post(route('create-contact'), this.data)
                .then(response => {
                    this.handleSuccess()
                    Object.keys(this.data).forEach(prop => {
                        this.data[prop] = ''
                    })
                    requestAnimationFrame(() => {
                        this.$refs.form.$refs.observer.reset();
                    });
                })
                .catch(e => this.handleError(e));
        }
    }
}
</script>